import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=0dd21f2b&"
import script from "./Swatch.vue?vue&type=script&lang=js&"
export * from "./Swatch.vue?vue&type=script&lang=js&"
import style0 from "./Swatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports